import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ServicecallService } from 'src/app';
import { Messages } from 'src/app/constants/messages';
import { ActionMode, ActionModeType, ConfigEntityOnboardFormModel, EntityOnboardModel, EntityOnboardStateModel, EntityPage, EntityValue } from 'src/app/model';

@Component({
  selector: 'app-add-alert-rule',
  templateUrl: './add-alert-rule.component.html',
  styleUrl: './add-alert-rule.component.css'
})
export class AddAlertRuleComponent {

  content: EntityOnboardModel;
  defaultAlertId: number;
  formStatus: ActionModeType;
  private _routerState: EntityOnboardStateModel;
  // Configuration
  private _tenantGenericConfig: any;
  private _entityDeviceOnboardFormConfig: ConfigEntityOnboardFormModel;

  //Subscription
  private _currentAlertRulesSubscription: Subscription;
  private _insertAlertRuleSubscription: Subscription;
  private _updateAlertRuleSubscription: Subscription;

  constructor(private _apiService: ServicecallService, private _router: Router) {
    this._setRouteState();
    this._setConfiguration();
    this._setEntityOnboardContent();
  }

  ngOnInit(): any { }

  ngOnDestroy() {
    this._currentAlertRulesSubscription?.unsubscribe();
    this._insertAlertRuleSubscription?.unsubscribe();
    this._updateAlertRuleSubscription?.unsubscribe();
  }

  private _setRouteState() {
    this._routerState = <EntityOnboardStateModel>history?.state;
  }
  /**
 * Sets configuration
 */
  private _setConfiguration() {
    this._tenantGenericConfig = this._apiService.getConfiguration('tenantGenericConfig')
      ? this._apiService.getConfiguration('tenantGenericConfig')
      : null;
    this._entityDeviceOnboardFormConfig = this._apiService.getConfiguration('entityDeviceOnboardFormConfig')
      ? this._apiService.getConfiguration('entityDeviceOnboardFormConfig')
      : null;
  }

  /**
   * Sets entity onboard content
   */
  private _setEntityOnboardContent() {
    let formFields = this._tenantGenericConfig?.eventsColumnHeader?.addAlertRuleFields?.formSectionList ?? [];
    const routerData = this._routerState?.data;
    const formData: any = {
      activeStatus: { active: routerData?.['active'] } ,
      alertDetails: { alertId: routerData?.['alertId'], alertDesc: routerData?.['alertDesc'], message: routerData?.['message'], alertSeverity: routerData?.['alertSeverity'] },
      notification: {
        notifications: {
          webNotification: routerData?.['webNotification'],
          autoClose: routerData?.['autoClose']
        }
      }
    }

    this.content = {
      entityType: EntityValue.ALERTPROFILE,
      pageType: EntityPage.ALERTPROFILE,
      formField: formFields,
      formResponse: this._entityDeviceOnboardFormConfig?.formResponse,
      bulkUploadEnable: false,
      data: this._routerState?.formStatus === ActionMode.ADD ? this._routerState?.data : formData,
      formStatus: this._routerState?.formStatus,
      path: 'events/alerts'
    };
  }

  setFormValues(event: any) {
    const payload = { ...event?.activeStatus, ...event?.alertDetails, ...event?.notification?.notifications };
    const defaultValues = {
      class: "Alert",
      action: "report as an incident",
      alertCategory: "near miss",
      categoryNature: "positive observation",
      excludedZoneRiskTypes: "high",
      sms: false,
      email: false,
      c2d: false,
      pushNotification: false,
      mtype: 0,
      triggerDelay: 0,
      duplicateDuration: 0,
      delayAlertDuration: 0,
      uom: "array"
    };
    if (this._routerState?.formStatus === ActionMode.ADD) {
      this.addAlertRule(payload, defaultValues);
    } else {
      this.editAlertRule(payload);
    }

  }

  addAlertRule(payload, defaultValues) {
    const reqPayload = [{ ...payload, ...defaultValues }];

    this._insertAlertRuleSubscription = this._apiService
      .inserAlertProfile(reqPayload)
      .subscribe(
        {
          next: () => {
            this._apiService.toasterService({
              type: 'success',
              msg: 'Alert Profile added successfully'
            });
            this._router.navigate(['events/alerts'],
            {
              state: {
                type: 'alertProfile'
              }
            });
          }, error: () => {
            this._apiService.toasterService({
              type: 'error',
              msg: Messages.ERROR
            });
          }
        }
      );
  }

  editAlertRule(payload) {
    const reqPayload = {
      _id: this._routerState?.data?.['_id'],
      alertId: this._routerState?.data?.['alertId'],
      tab: "tenant",
      metadata: {
        createdBy: localStorage.getItem('userId')
          ? localStorage.getItem('userId')
          : null
      },
      set: { ...payload },
      action: true
    }
    this._updateAlertRuleSubscription = this._apiService
      .updateAlertRule(reqPayload)
      .subscribe(
        {
          next: (response: any) => {
            if (response?.status) {
              if (response?.['response']) {
                this._apiService.toasterService({
                  type: 'success',
                  msg: 'Alert Profile updated successfully'
                });
                this._router.navigate(['events/alerts'],
                {
                  state: {
                    type: 'alertProfile'
                  }
                });
              }
            } else {
              this._apiService.toasterService({
                type: 'error',
                msg: Messages.ERROR
              });
            }
          }, error: () => {
            this._apiService.toasterService({
              type: 'error',
              msg: Messages.ERROR
            });
          }
        }
      );
  }


}
